function validateNonAuth(values) {
  let errors = {};
  if (!values.otd_comment) {
    errors.otd_comment = "Please enter at least some kind of comment.";
  }
  if (!values.otd_guest) {
    errors.otd_guest = "Please enter your name or Login / Register with the link above.";
  }
  return errors;
}

// Errors for Chimney logged in users
function validateAuth(values) {
  let errors = {};
  if (!values.otd_comment) {
    errors.otd_comment = "Please enter at least some kind of comment.";
  }
  return errors;
}

export { validateNonAuth, validateAuth };
